<template>
  <div class="create_wrapper">
    <Breadcrumb :items="items" />
    <div class="custom_card">
      <!-- START:: CARD TITLE -->
      <div class="card-header">
        <h4 class="card-title">{{ $t("CRUD.Update.main_title") }}</h4>
      </div>
      <!-- END:: CARD TITLE -->

      <!-- START:: CREATE FORM WRAPPER -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between">
            <!-- START:: INPUT WRAPPER -->
            <div class="col-lg-12 py-0">
              <!-- START:: TITLE INPUT -->
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  id="name_input"
                  @input="checkIfInputIsEmpty"
                  v-model.trim="updateData.question"
                />
                <label for="name_input" class="form-label">{{
                  $t("faqs.data.question")
                }}</label>
              </div>
              <!-- END:: TITLE INPUT -->
            </div>
            <!-- END:: INPUT WRAPPER -->
            <!-- START:: INPUT WRAPPER -->
            <div class="col-lg-12 py-0">
              <!-- START:: TEXT AREA -->
              <div class="input_wrapper top_label">
                <label for="desc" class="form-label">{{
                  $t("faqs.data.answer")
                }}</label>
                <textarea
                  v-on:keydown.enter.prevent="validateCreateForm"
                  class="form-control"
                  id="desc"
                  v-model.trim="updateData.answer"
                  rows="5"
                ></textarea>
              </div>
              <!-- END:: TEXT AREA -->
            </div>
            <!-- START:: INPUT WRAPPER -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <!-- START:: BUTTON -->
          <button
            class="button_style_1"
            :class="{buttonIndex: btnIsLoading}"
            :disabled="btnIsLoading"
          >
            {{ $t("Forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
          <!-- END:: BUTTON -->
        </div>
      </form>
      <!-- END:: CREATE FORM WRAPPER -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Update",

  data() {
    return {
      // START:: BREADCRUMBS ITEMS
      items: [
        {
          text: this.$t("mainHome"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("faqs.title"),
          disabled: false,
          href: "/faqs",
        },
        {
          text: this.$t("edit"),
          disabled: true,
          href: "",
        },
      ],
      // END:: BREADCRUMBS ITEMS

      // START:: BUTTON LOADER HANDLING DATA
      btnIsLoading: false,
      // END:: BUTTON LOADER HANDLING DATA

      // START:: SELECTED FILE DATA
      selectedFile: {
        file: null,
        name: null,
        path: null,
      },
      // END:: SELECTED FILE DATA

      // START:: CREATE DATA
      updateData: {
        question: null,
        answer: null,
      },
      // END:: CREATE DATA
    };
  },

  methods: {
    // START:: Uplode Avatar
    uplodeImg_1(obj) {
      this.updateData.avatar = obj;
    },
    // END:: Uplode Avatar

    // START:: CHECK IF INPUT IS EMPTY (SPECIFIC TO ANIMATED PLACEHOLDER INPUTS)
    checkIfInputIsEmpty(e) {
      let inputElement = e.currentTarget;
      if (inputElement.value.length > 0) {
        inputElement.classList.add("not_empty");
      } else {
        inputElement.classList.remove("not_empty");
      }
    },
    // END:: CHECK IF INPUT IS EMPTY (SPECIFIC TO ANIMATED PLACEHOLDER INPUTS)

    // START:: VALIDATE CREATE FORM
    validateCreateForm() {
      if (!this.btnIsLoading) {
        this.btnIsLoading = true;
        if (!this.updateData.question) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("faqs.validation.question"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.updateData.answer) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("faqs.validation.answer"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("global.edSuccess"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        }
      }
    },
    // END:: VALIDATE CREATE FORM
  },

  mounted() {
    this.updateData.title = "Mahmoud Siliman";
    this.updateData.single_select_value = {id: 2, name: "Option_2"};
  },
};
</script>
